import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type MilestoneEvents =
  | 'MILESTONES_CLICK_ADD_MILESTONE_BUTTON'
  | 'MILESTONES_CLICK_ADD_MILESTONE_PROCESS'
  | 'MILESTONES_CLICK_MILESTONE_OVERFLOW_ACTION_MENU_BUTTON'
  | 'MILESTONES_CLICK_EDIT_MILESTONE_OVERFLOW_ACTION_PROCESS_BUTTON'
  | 'MILESTONES_CLICK_DELETE_MILESTONE_ACTION_BUTTON'
  | 'MILESTONES_CLICK_DELETE_MILESTONE_DIALOG_CONFIRM_BUTTON'
  | 'MILESTONES_CLICK_SUBMIT_ADD_MILESTONE_BUTTON'
  | 'MILESTONES_CLICK_SUBMIT_EDIT_MILESTONE_BUTTON'
  | 'MILESTONES_CLICK_EXPAND_MILESTONE_ACCORDION';

export const milestone: Record<MilestoneEvents, MixpanelEvent> = {
  MILESTONES_CLICK_ADD_MILESTONE_BUTTON: {
    eventDescription: 'Milestones Click Add Milestone Button',
    eventKey: 'milestones-click-add-milestone-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.EXPAND_BUTTON
  },
  MILESTONES_CLICK_ADD_MILESTONE_PROCESS: {
    eventDescription: 'Milestones Click Add Milestone Process from Dropdown',
    eventKey: 'milestones-click-add-milestone-process-dropdown',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.MUI_SELECT
  },
  MILESTONES_CLICK_MILESTONE_OVERFLOW_ACTION_MENU_BUTTON: {
    eventDescription: 'Milestones Click Milestone Button actions button',
    eventKey: 'milestones-click-milestone-actions-menu-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.EXPAND_BUTTON
  },
  MILESTONES_CLICK_EDIT_MILESTONE_OVERFLOW_ACTION_PROCESS_BUTTON: {
    eventDescription: 'Milestones Click Edit Milestone Process from Dropdown',
    eventKey: 'milestones-click-edit-milestone-process-dropdown',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.MUI_SELECT
  },
  MILESTONES_CLICK_DELETE_MILESTONE_ACTION_BUTTON: {
    eventDescription: 'Milestones Click Delete Milestone Action',
    eventKey: 'milestones-click-delete-milestone-action',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.MUI_SELECT
  },
  MILESTONES_CLICK_DELETE_MILESTONE_DIALOG_CONFIRM_BUTTON: {
    eventDescription: 'Milestones Click Delete Dialog confirm button',
    eventKey: 'milestones-click-delete-milestone-dialog-confirm-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  MILESTONES_CLICK_SUBMIT_ADD_MILESTONE_BUTTON: {
    eventDescription: 'Milestones Click Submit Add Milestone confirm button',
    eventKey: 'milestones-click-submit-add-milestone-dialog-confirm-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  MILESTONES_CLICK_SUBMIT_EDIT_MILESTONE_BUTTON: {
    eventDescription: 'Milestones Click Submit Edit Milestone confirm button',
    eventKey: 'milestones-click-submit-edit-milestone-dialog-confirm-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  MILESTONES_CLICK_EXPAND_MILESTONE_ACCORDION: {
    eventDescription: 'Milestones Click Expand Milestone Accordion',
    eventKey: 'milestones-click-expand-milestone-accordion',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.EXPAND_BUTTON
  }
} as const;
